import React, { useContext } from "react";
import AlertPopup from "./Components/AlertPopup";
import { PopupContext } from "./Context/PopupContext";

export default function AppRouterPopups() {
  const {
    confirmationPopupVisibility,
    confirmationPopupText,
    setConfirmationPopupText,
    setConfirmationPopupVisibility,
  } = useContext(PopupContext);
  return (
    <>
      {confirmationPopupVisibility ? (
        <AlertPopup
          confirmationPopupText={confirmationPopupText}
          setConfirmationPopupVisibility={setConfirmationPopupVisibility}
          confirmationPopupVisibility={confirmationPopupVisibility}
        />
      ) : null}
    </>
  );
}
